import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { RefreshAuthTokenRequestForTest, RefreshAuthTokenResponseForTest } from "@maven-rest/sso/AuthToken.dto";
import { AuthTokenUrl } from "@maven-rest/sso/AuthToken.url";

export function useRefreshAuthTokenMutation(
  options?: SimpleMutationOptions<RefreshAuthTokenResponseForTest, RefreshAuthTokenRequestForTest>
) {
  return useBaseMutation({
    fnOption: {
      host: process.env.REACT_APP_SSO_BE_URL,
      url: AuthTokenUrl.refreshAuthToken,
    },
    ...options,
  });
}
